import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import en from '@/locales/en/translation.json'
import es from '@/locales/es/translation.json'
import fr from '@/locales/fr/translation.json'
import de from '@/locales/de/translation.json'
import it from '@/locales/it/translation.json'
import pt from '@/locales/pt/translation.json'
import nl from '@/locales/nl/translation.json'
import pl from '@/locales/pl/translation.json'
import cs from '@/locales/cs/translation.json'
import sk from '@/locales/sk/translation.json'

const resources = {
  en: {
    translation: en
  },
  es: {
    translation: es
  },
  fr: {
    translation: fr
  },
  de: {
    translation: de
  },
  it: {
    translation: it
  },
  pt: {
    translation: pt
  },
  nl: {
    translation: nl
  },
  pl: {
    translation: pl
  },
  cs: {
    translation: cs
  },
  sk: {
    translation: sk
  }
}

function FindInitialLanguage() {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const lang = urlParams.get('lang')

  if (
    lang === 'en' ||
    lang === 'es' ||
    lang === 'de' ||
    lang === 'fr' ||
    lang === 'it' ||
    lang === 'pt' ||
    lang === 'nl' ||
    lang === 'pl' ||
    lang === 'cs' ||
    lang === 'sk'
  ) {
    localStorage.setItem('userPreferredLang', lang)
    return lang
  }

  const storedLang = localStorage.getItem('userPreferredLang')
  if (storedLang) return storedLang

  const userLocale = navigator.languages
  const language = userLocale.find((lng) => {
    if (
      lng.substring(0, 2) === 'es' ||
      lng.substring(0, 2) === 'fr' ||
      lng.substring(0, 2) === 'de' ||
      lng.substring(0, 2) === 'en' ||
      lng.substring(0, 2) === 'it' ||
      lng.substring(0, 2) === 'pt' ||
      lng.substring(0, 2) === 'nl' ||
      lng.substring(0, 2) === 'pl' ||
      lng.substring(0, 2) === 'cs' ||
      lng.substring(0, 2) === 'sk'
    ) {
      return lng
    }
  })
  if (language) {
    localStorage.setItem('userPreferredLang', language.substring(0, 2))
    return language.substring(0, 2)
  }
  localStorage.setItem('userPreferredLang', 'en')
  return 'en'
}

i18next.use(initReactI18next).use(Backend).init({
  lng: FindInitialLanguage(),
  fallbackLng: 'en',
  resources
})
